import React from "react";
import "../../style/AboutSection.css";
import Brocher_front from "../../resources/Brocher_front.png";

function AboutSection() {
  const handleVisitClick = () => {
    window.location.href = "https://iitm.tech";
  };

  return (
    <div className="about-section">
      <div className="about-content">
        <div className="about-text">
          <h2>About IITM</h2>
          <p>
            IITM College of Engineering, Bahadurgarh is committed to
            providing value-based, quality education through a blend of
            rigorous academic training and practical exposure. The
            institute offers state-of-the-art facilities and a progressive
            learning environment designed to nurture innovation,
            technical excellence, and professional growth.
          </p>
          <p>
            Located at Lush Green state of the art campus, Bahadurgarh
            (Haryana), IITM College of Engineering offers programs in
            Engineering, Management, Computer Applications, and
            related disciplines, serving a diverse student community.
            The college emphasizes hands-on learning,
            industry-oriented training, holistic development and
            preparing students to meet global professional standards.
          </p>
          <button className="submit-button" onClick={handleVisitClick}>
            Visit us To Know More →
          </button>
        </div>

        <div className="award-poster">
          <img
            src={Brocher_front}
            alt="Award Poster"
            className="award-poster-image"
          />
        </div>
      </div>
    </div>
  );
}

export default AboutSection;
